export default [
  {
    path: '/pages/operation/partnerManagement',
    meta: { title: '伙伴管理' },
    name: '/pages/operation/partnerManagement',
    component: () => import('@/views/operation/partnerManagement.vue'),
  },
  {
    path: '/pages/operation/projectManagement',
    meta: { title: '经营项目' },
    name: '/pages/operation/projectManagement',
    component: () => import('@/views/operation/projectManagement.vue'),
  },
  {
    path: '/pages/operation/contractManagement',
    meta: { title: '经营合同' },
    name: '/pages/operation/contractManagement',
    component: () => import('@/views/operation/contractManagement.vue'),
  },
  {
    path: '/pages/operation/accountLedger',
    meta: { title: '经营台账' },
    name: '/pages/operation/accountLedger',
    component: () => import('@/views/operation/accountLedger.vue'),
  },
  {
    path: '/pages/operation/settlementManagement',
    meta: { title: '结算管理' },
    name: '/pages/operation/settlementManagement',
    component: () => import('@/views/operation/settlementManagement.vue'),
  }
]